import { Button, Popover, SegmentedControl, Stack, Text } from "@mantine/core";
import { IconCalendar, IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./FilterSelect.module.css";

export const DateFilterSelect = ({ onChange }) => {
    const { t } = useTranslation();
    const rangeOptions = [
        { value: '', label: t('dateFilter.allTime') },
        { value: '7d', label: t('dateFilter.last7') },
        { value: '14d', label: t('dateFilter.last14') },
        { value: '30d', label: t('dateFilter.last30') },
        { value: '90d', label: t('dateFilter.last90') },
    ];
    const [opened, setOpened] = useState(false);
    const [dateType, setDateType] = useState('online');
    const [range, setRange] = useState('');

    const emit = (nextRange, nextType) => onChange({
        date_filter_range: nextRange || null,
        date_filter_type: nextRange ? nextType : undefined,
    });

    return (
        <Popover opened={opened} onChange={setOpened} position="bottom-start" withinPortal shadow="md">
            <Popover.Target>
                <Button
                    variant="default"
                    radius={8}
                    w={140}
                    justify="space-between"
                    className={classes.trigger} c="var(--trigger-fg)"
                    leftSection={<IconCalendar size={16} className={classes.chevron} />}
                    rightSection={opened
                        ? <IconChevronUp size={16} className={classes.chevron} />
                        : <IconChevronDown size={16} className={classes.chevron} />}
                    onClick={() => setOpened((o) => !o)}
                    fw={400}
                >
                    {t('dateFilter.date')}
                </Button>
            </Popover.Target>
            <Popover.Dropdown p="md" w={234} className={classes.dropdown}>
                <Text fz={10} fw={600} className={classes.sectionLabel} c="var(--section-label-fg)" tt="uppercase" mb="xs">{t('dateFilter.filterBy')}</Text>
                <SegmentedControl
                    classNames={{ label: classes.segmentLabel }}
                    fullWidth
                    size="xs"
                    value={dateType}
                    onChange={(value) => {
                        setDateType(value);
                        emit(range, value);
                    }}
                    data={[
                        { value: 'online', label: t('booking.goalDates.onlineDate') },
                        { value: 'creation', label: t('ads.creationDate') },
                    ]}
                    mb="sm"
                />
                <Stack gap={2}>
                    {rangeOptions.map((option) => (
                        <Button
                            key={option.value}
                            variant={range === option.value ? 'light' : 'subtle'}
                            color={range === option.value ? 'smartico-blue' : 'dark'}
                            className={range === option.value ? undefined : classes.rangeOption}
                            c={range === option.value ? undefined : 'var(--range-fg)'}
                            justify="flex-start"
                            fullWidth
                            onClick={() => {
                                setRange(option.value);
                                emit(option.value, dateType);
                                setOpened(false);
                            }}
                        >
                            {option.label}
                        </Button>
                    ))}
                </Stack>
            </Popover.Dropdown>
        </Popover>
    );
};
